import axios from 'axios';

import store from '../store/store';
import router from '../router';
import HttpStatus from '../utils/httpStatusCodes';
import { backendRouteNeedAuthentication } from '@/service/api/helper';

axios.defaults.baseURL = process.env.VUE_APP_CORE_HOST;

axios.interceptors.request.use((config) => {
    const accessToken = store.getters.accessToken;
    if (accessToken && backendRouteNeedAuthentication(config.url)) {
        config.headers['X-USER-AUTH-TOKEN'] = accessToken;
    }

    return config;
});

const logoutAndRedirectToLogin = async () => {
    await store.dispatch('deleteAccessToken');
    await store.dispatch('clearEnterpriseData');

    if (router.currentRoute.name !== 'login') {
        await router.push({ name: 'login' }).catch(() => {});
    }
};

axios.interceptors.response.use(async (response) => {
    return response;
}, async (error) => {
    if (error && error.response) {
        if (error.response.status === HttpStatus.HTTP_FORBIDDEN) {
            if (error.response.data?.apiCode === 'auth_failed') {
                await logoutAndRedirectToLogin();
            } else {
                const accessToken = store.getters.accessToken;
                const isSessionCheckRequest = error.config?.url?.includes('/users/permissions');

                if (accessToken && !isSessionCheckRequest) {
                    try {
                        await axios.get('/users/permissions');
                    } catch {
                        await logoutAndRedirectToLogin();
                    }
                }
            }
        }

        if (error.response.status === HttpStatus.HTTP_SERVICE_UNAVAILABLE) {
            await store.dispatch('deleteAccessToken');
            await store.dispatch('clearEnterpriseData');
            await router.push({ name: 'maintenance-mode' }).catch(() => {
            });
        }
    }

    return Promise.reject(error);
});
